import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .password-email-container {
    padding: 1rem;
  }

  .password-email-container.password-loading,
  .password-email-container.password-success {
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
  }
  .password-email-container.password-success h4 {
    color: ${colors.primary};
  }
  .error-password {
    font-weight: bold;
    color: ${colors.danger};
  }
  .disclaimer-password {
    display: none;
  }
  @media screen and (max-width: 992px) {
    .disclaimer-password {
      display: initial;
    }
  }
`
